<template>
  <ol
    class="spoiler_content"
  >
    <li v-html="rulesUrl" />
    <li>{{ $t('2. Обратите внимание, что ежемесячный возврат внутриигровой валюты производится в течение 5 рабочих дней после даты формирования выписки.') }}</li>
    <li v-html="bankSupportUrl" />
  </ol>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import { getRulesUrl, getBankSupportUrl } from '@/helpers'

@Component({})
class WhereIsMyAccuralsTinkoff extends Vue {
  @Prop({ type: String, required: true }) partner
  @Prop({ type: String, required: true }) currentCountry

  get rulesUrl () {
    return this.$t(
      '1. В истории начисления бонусов содержится информация только о ежемесячном возврате внутриигровой валюты и дополнительных бонусах за оборот по карте, в соответствии с %(link_start)sправилами программы%(link_stop)s.',
      { link_start: `<a class='link' target='_blank' href='${getRulesUrl(this.partner)}?country=RU'>`, link_stop: `</a>` }
    )
  }

  get bankSupportUrl () {
    return this.$t(
      '3. При возникновении вопросов касательно суммы начисленной внутриигровой валюты обратитесь в службу поддержки %(link_start)sбанка%(link_stop)s или по телефону на оборотной стороне карты.',
      { link_start: `<a class='link' href="${getBankSupportUrl(this.partner)}" target="_blank">`, link_stop: '</a>' }
    )
  }
}

export default WhereIsMyAccuralsTinkoff
</script>
